import { combineCityState, buildChildStatus } from './helpers';

export function chapter4Transform(formData) {
  const parsedFormData = JSON.parse(formData);
  const transformedValue = { ...parsedFormData };
  // combine city and state/country for place of marriage and place of separation
  // for marriage and each previous/veteran previous marriage
  if (parsedFormData?.marriageToVeteranEndLocation) {
    transformedValue.placeOfMarriageTermination = combineCityState(
      parsedFormData.marriageToVeteranEndLocation?.city,
      parsedFormData.marriageToVeteranEndLocation?.state ||
        parsedFormData.marriageToVeteranEndLocation?.otherCountry,
    );
  }

  if (parsedFormData?.marriageToVeteranStartLocation) {
    transformedValue.placeOfMarriage = combineCityState(
      parsedFormData.marriageToVeteranStartLocation?.city,
      parsedFormData.marriageToVeteranStartLocation?.state ||
        parsedFormData.marriageToVeteranStartLocation?.otherCountry,
    );
  }

  if (parsedFormData?.spouseMarriages?.length) {
    transformedValue.spouseMarriages = parsedFormData.spouseMarriages.map(
      marriage => {
        return {
          ...marriage,
          locationOfMarriage: combineCityState(
            marriage.locationOfMarriage?.city,
            marriage.locationOfMarriage?.state ||
              marriage.locationOfMarriage?.otherCountry,
          ),
          locationOfSeparation: combineCityState(
            marriage.locationOfSeparation?.city,
            marriage.locationOfSeparation?.state ||
              marriage.locationOfSeparation?.otherCountry,
          ),
          reasonForSeparationExplanation: marriage?.separationExplanation || '',
        };
      },
    );
  }

  if (parsedFormData?.veteranMarriages?.length) {
    transformedValue.veteranMarriages = parsedFormData.veteranMarriages.map(
      marriage => {
        return {
          ...marriage,
          locationOfMarriage: combineCityState(
            marriage.locationOfMarriage?.city,
            marriage.locationOfMarriage?.state ||
              marriage.locationOfMarriage?.otherCountry,
          ),
          locationOfSeparation: combineCityState(
            marriage.locationOfSeparation?.city,
            marriage.locationOfSeparation?.state ||
              marriage.locationOfSeparation?.otherCountry,
          ),
          reasonForSeparationExplanation: marriage?.separationExplanation || '',
        };
      },
    );
  }

  if (parsedFormData?.veteransChildren?.length) {
    transformedValue.veteransChildren = parsedFormData.veteransChildren.map(
      child => {
        return {
          ...child,
          childPlaceOfBirth: combineCityState(
            child.birthPlace?.city,
            child.birthPlace?.state || child.birthPlace?.otherCountry,
          ),
          childStatus: buildChildStatus(child),
        };
      },
    );
  }

  // yes/no for separation due to marital discord...
  if (parsedFormData?.separationDueToAssignedReasons) {
    if (parsedFormData?.survivorsBenefitsForm2025VersionEnabled) {
      if (
        parsedFormData.separationDueToAssignedReasons === 'MEDICAL_FINANCIAL'
      ) {
        transformedValue.separationDueToAssignedReasons = true;
      } else {
        transformedValue.separationDueToAssignedReasons = false;
      }
    } else {
      transformedValue.separationDueToAssignedReasons = true;
    }
  }
  // combine dates of marriage
  if (
    parsedFormData?.marriageToVeteranStartDate ||
    parsedFormData?.marriageToVeteranEndDate
  ) {
    transformedValue.marriageDates = {
      from: parsedFormData.marriageToVeteranStartDate || '',
      to: parsedFormData.marriageToVeteranEndDate || '',
    };
  }

  // If remarriage marked as still married, set how did marriage end to didNotEnd.
  if (parsedFormData?.stillRemarried) {
    transformedValue.remarriageEndCause = 'didNotEnd';
  }

  // Fixes for a11y issue when hideIf field starts with the same word as trigger field.
  if (parsedFormData?.endCauseExplanation) {
    transformedValue.remarriageEndCauseExplanation =
      parsedFormData.endCauseExplanation;
  }

  if (parsedFormData?.marriageEndedExplanation) {
    transformedValue.howMarriageEndedExplanation =
      parsedFormData.marriageEndedExplanation;
  }

  if (parsedFormData?.typeOfMarriageExplanation) {
    transformedValue.marriageTypeExplanation =
      parsedFormData.typeOfMarriageExplanation;
  }

  return JSON.stringify(transformedValue);
}
